const register = {
  page: {
    title: 'Ihre Registrierung',
    description: 'Willkommen beim Online-Bestellservice Ihrer lokalen Apotheken! Registrieren Sie sich in nur 60 Sekunden kostenfrei!',
  },
  forms: {
    nameTitle: 'Ihr Name',
    salutation: 'Anrede',
    firstName: 'Vorname *',
    lastName: 'Nachname *',
    your_credentials: 'Ihre Anmeldedaten',
    email: 'E-Mail-Adresse *',
    password: 'Passwort *',
    passwordHint: 'Hinweis:',
    passwordHintText: 'Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Zahl und 1 Sonderzeichen enthalten',
    phoneTitle: 'Wie kann die Apotheke Sie erreichen?',
    phoneNumber: 'Telefonnummer *',
    ourPromise: 'Unser Versprechen:',
    promiseText: 'Wir nutzen die Telefonnummer nur für eventuelle Rückfragen der Apotheke zu Ihren Vorbestellungen. Außerdem werden Sie per SMS und E-Mail über den Status Ihrer Bestellung informiert.',
    pleaseFill: 'Bitte füllen Sie die Pflichtfelder aus',
    register: 'Konto erstellen',
    newsletter: 'Melden Sie sich hiermit für unseren kostenfreien Newsletter an und profitieren Sie von regelmäßigen Produktempfehlungen und Neuigkeiten rund um Ihre Apotheke. Die Anmeldung zum Newsletter ist freiwillig und kann jederzeit widerrufen werden.',
    dataSharing: 'Datenfreigabe',
    dataSharingLabel: 'Mit Ihrer Einwilligung erlauben Sie Ihrer Apotheke den Zugriff auf die von Ihnen bereitgestellten Daten. Sie können die Freigabe jederzeit eigenständig in Ihrem Profil widerrufen.',
  },
  login: 'Anmelden',
  register_confirmation_title: 'Vielen Dank für Ihre Registrierung',
  register_confirmation_description: 'Eine E-Mail wurde an {email} gesendet. Diese enthält einen Link, den Sie anklicken müssen, um ihr Benutzerkonto zu bestätigen.',
  verification_successful: 'Verifizierung erfolgreich',
  verification_successful_text: 'Ihr IhreApotheken-Kundenkonto wurde erfolgreich verifiziert. Sie können die Daten in Ihrem Kundenkonto nun vervollständigen und den Status Ihrer Bestellungen verfolgen.',
  already_have_account: 'Sie haben schon ein Konto?',
  signup_advantages_title: 'Ihre Vorteile',
  signup_advantages_subtitle: 'Nutzen Sie Ihren persönlichen Account und verwalten Sie schnell und einfach Ihre Bestellungen und Adressen.',
  go_to_homepage: 'Zur Startseite',
  go_to_my_account: 'Zum Kundenkonto',
  error: 'Fehler',
  invalid_confirmation_token: 'Bestätigungstoken ungültig',
}

export default register
